//sfdx-source/flair/main/default/classes/enums/EmployeeNotificationMessageType.cls

// NOTE: Only include notification types that are supported by the frontend.
// Unsupported types (e.g., time-entry.added, time-entry.deleted, time-sheet.approved)
// should NOT be included here as they would be counted but not displayed.
export const NotificationTypes = {
  ABSENCE_APPROVED: 'absence.approved',
  ABSENCE_CREATED: 'absence.created',
  ABSENCE_REJECTED: 'absence.rejected',
  ABSENCE_DELETED: 'absence.deleted',
  ABSENCE_REQUEST_CREATED: 'absence-request.created',
  APPROVAL_REQUEST_CREATED: 'approval-request.created',
  TIME_ENTRY_CHANGES_APPROVED: 'time-entry-change-request.approved',
  TIME_ENTRY_CHANGES_CREATED: 'time-entry-change-request.created',
  TIME_ENTRY_CHANGES_REJECTED: 'time-entry-change-request.rejected',
  TIME_TRACKING_CLOCK_OUT_LIMIT: 'time-tracking.clock-out-limit',
  TIME_TRACKING_CLOCK_OUT_LIMIT_MANAGER:
    'time-tracking.clock-out-limit.manager',
  CELEBRATION_RECEIVED: 'celebration.received',
  COMMENT_CREATED: 'comment.created',
  COMMENT_MENTIONED: 'comment.mentioned',
  CANDIDATE_EVALUATION_REQUESTED: 'candidate-evaluation.requested',
  CANDIDATE_EVALUATION_COMPLETED: 'candidate-evaluation.completed',
  WORKFLOW_ASSIGNED_PENDING_ITEMS: 'workflow.assigned.pending-items',
  WORKFLOW_DIGEST_EXPIRING_WORKFLOW_ITEMS:
    'workflow.digest.expiring-workflow-items',
  TICKET_SUBMITTED: 'ticket.submitted',
  TICKET_SHARED: 'ticket.shared',
  TICKET_STATUS_CHANGED: 'ticket.status-changed',
  TICKET_CLOSED: 'ticket.closed',
  // Time balance
  TIME_BALANCE_WITHDRAWAL_CREATED: 'time-balance-withdrawal.created',
  // Employee data change request
  EMPLOYEE_DATA_CHANGE_REQUEST_APPROVED:
    'employee-data-change-request.approved',
};
